// src/features/auth/login/LoginHeader.jsx
import React from 'react';
import { FiX } from 'react-icons/fi';

const LoginHeader = ({ handleCloseModal }) => (
    <div className="p-6 text-center bg-gradient-to-b from-brand-900 to-brand-800 dark:from-brand-900 dark:to-surface-850 relative">
        <h5 className="text-white text-xl font-bold">Iniciar Sesión</h5>
        <p className="text-brand-200 text-sm mt-1">Bienvenido de vuelta</p>
        <button
            className="absolute top-4 right-4 p-1 text-white/60 hover:text-white hover:bg-white/10 rounded-lg transition-all duration-200"
            onClick={handleCloseModal}
        >
            <FiX className="w-5 h-5" />
        </button>
    </div>
);

export default LoginHeader;
